// hooks/useChassisVerify.js
import { useState, useCallback } from "react"
import { useVerifyFullChassis } from "./stockHook"

export const useChassisVerify = ({ formik, chassisCodesData, isEdit = false, id = "" }) => {
  const [isValidChassis, setIsValidChassis] = useState(true)
  const { mutateAsync: fullChassisVerify, isPending: checking } = useVerifyFullChassis()

  const verifyChassis = useCallback(async () => {
    const { chassis_number: chassisNumber, vs_chassis_code_id: chassisCodeId } = formik.values

    if (!chassisNumber || !chassisCodeId) {
      setIsValidChassis(true)
      formik.setFieldError("chassis_number", undefined)
      return
    }

    // find chassis code
    const r = chassisCodesData?.find(item => Number(item?.id) === Number(chassisCodeId))
    const chassisCode = r?.name ?? ""

    if (!chassisCode) {
      setIsValidChassis(true)
      formik.setFieldError("chassis_number", undefined)
      return
    }

    const fullChassis = `${chassisCode}-${chassisNumber}`

    try {
      const res = await fullChassisVerify({
        full_chassis: fullChassis,
        is_edit: isEdit ? 1 : 0,
        identifier: id ?? "",
      })

      const exists =
        res?.success &&
        res.data?.exists &&
        fullChassis === res.data?.full_chassis

      if (exists) {
        setIsValidChassis(false)
        formik.setFieldError("chassis_number", "Chassis number already exists!")
        formik.setFieldTouched("chassis_number", true, false)
      } else {
        setIsValidChassis(true)
        formik.setFieldError("chassis_number", undefined)
      }
    } catch (error) {
      setIsValidChassis(true)
      formik.setFieldError("chassis_number", undefined)
    }
  }, [formik, chassisCodesData, fullChassisVerify, isEdit, id])

  return { isValidChassis, checking, verifyChassis }
}
